/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Notification level.
 */
export var NotificationLevel;
(function (NotificationLevel) {
    NotificationLevel["INFO"] = "info";
    NotificationLevel["WARNING"] = "warning";
    NotificationLevel["ERROR"] = "error";
})(NotificationLevel || (NotificationLevel = {}));
